import {REPORTS_STATUS} from "../../../../../base/constants/reports";

export const getNewReportIds = (reports = []) => reports
    .filter((report) => report.status === REPORTS_STATUS.NEW_REPORT)
    .map((report) => report.id)